import { PinPreview } from '@lessonup/pin-renderer';
import { TeacherPin } from '@lessonup/pins-shared';
import { borderRadius, color, spacing, styled, Tag, useTranslation } from '@lessonup/ui-components';
import React from 'react';

export interface GeneratedPinItemProps {
  pin: TeacherPin;
}

export const GeneratedPinItem = ({ pin }: GeneratedPinItemProps) => {
  const { t } = useTranslation(['chatGPT']);

  const getTagTranslationKey = (type: string) => {
    switch (type) {
      case 'WORD_CLOUD':
        return 'wordweb';
      case 'OPEN_QUESTION':
        return 'openQuestion';
      default:
        return 'slide';
    }
  };

  const tagTranslationKey = getTagTranslationKey(pin.type);

  return (
    <StyledGeneratedPinItem>
      <StyledPinPreviewContainer>
        <PinPreview pin={pin} />
        <StyledTag colorMode="tertiary">{t(tagTranslationKey)}</StyledTag>
      </StyledPinPreviewContainer>
    </StyledGeneratedPinItem>
  );
};

const StyledPinPreviewContainer = styled.div`
  border-radius: ${borderRadius.rounded4};
  overflow: hidden;
  aspect-ratio: 16/9;
  position: relative;
`;

const StyledTag = styled(Tag)`
  position: absolute;
  bottom: ${spacing.size12};
  right: ${spacing.size12};
`;

const StyledGeneratedPinItem = styled.li`
  background: ${color.neutral.surface.background};
  border-radius: ${borderRadius.rounded4};
  list-style: none;
  padding: 0px;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  border: 1px solid ${color.neutral.outline.background};
`;
